import { http, camelify } from '../rest';

export function fetch(http, camelify, demo) {
  return {
    async execute(date) {
      let data;
      if (demo) {
        const file = await import('./fetchBilling.data');
        data = file.default(date);
      } else {
        const response = await http.get(`/invoices?date=${date}`);
        data = response.data;
      }
      return camelify(data);
    },
  };
}

export default fetch(http, camelify, process.env.DEMO);
